
const submit = document.querySelector('button[name=checkout]');
const hidden = document.querySelector('.js-input-hidden');

async function updateCartAttributes(attributes) {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes })
  });
}

submit.addEventListener('click', (e) => {
  const attribute = {
    '生年月日': hidden.value,
  };
  updateCartAttributes(attribute);
});